import ConversationType from 'owa-service/lib/contract/ConversationType';
import ItemId from 'owa-service/lib/contract/ItemId';
import { TableView } from 'owa-mail-list-store';
import TableViewConversationRelation from 'owa-mail-list-store/lib/store/schema/TableViewConversationRelation';
import getShouldShowRSVPForConversationAndPrepareItem from 'owa-listview-rsvp/lib/utils/getShouldShowRSVPForConversationAndPrepareItem';

function getEffectiveMentioned(conversationType: ConversationType): boolean {
    return conversationType.GlobalMentionedMe || conversationType.GlobalAtAllMention;
}

export default function mapConversationTypeToConversationRelation(
    conversationType: ConversationType,
    tableView: TableView
): TableViewConversationRelation {
    return <TableViewConversationRelation>{
        categories: conversationType.Categories,
        charm: conversationType.Charm ? conversationType.Charm : 'None',
        draftItemIds: conversationType.DraftItemIds
            ? conversationType.DraftItemIds.map(baseDraftItemId => (<ItemId>baseDraftItemId).Id)
            : [],
        effectiveMentioned: getEffectiveMentioned(conversationType),
        executeSearchSortOrder: conversationType.SortOrderSource,
        flagStatus: conversationType.FlagStatus,
        hasAttachments: conversationType.HasAttachments,
        hasIrm: conversationType.HasIrm,
        iconIndex: conversationType.IconIndex,
        id: conversationType.ConversationId.Id,
        importance: conversationType.Importance,
        instanceKey: conversationType.InstanceKey,
        itemClasses: conversationType.ItemClasses,
        itemIds: conversationType.ItemIds.map(baseItemId => (<ItemId>baseItemId).Id),
        lastDeliveryOrRenewTimeStamp: conversationType.LastDeliveryOrRenewTime,
        lastDeliveryTimeStamp: conversationType.LastDeliveryTime,
        lastModifiedTimeStamp: conversationType.LastModifiedTime,
        lastSender: conversationType.LastSender
            ? conversationType.LastSender
            : conversationType.From, // lastSender is null in search response, use From instead
        parentFolderId: conversationType.ParentFolderId ? conversationType.ParentFolderId.Id : null, // This value only exists in search items
        previewText: conversationType.Preview,
        returnTime: conversationType.ReturnTime ? conversationType.ReturnTime : null,
        systemCategories: conversationType.SystemCategories,
        uniqueRecipients: conversationType.UniqueRecipients,
        uniqueSenders: conversationType.UniqueSenders,
        unreadCount: conversationType.UnreadCount,
        globalLikeCount: conversationType.GlobalLikeCount ? conversationType.GlobalLikeCount : null,
        shouldShowRSVP: getShouldShowRSVPForConversationAndPrepareItem(conversationType, tableView),
    };
}
